module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'dashboard'
      }
    }
  }, [_vm._v("Dashboard")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("License Expiry")])]), _vm._v(" "), _vm._l((_vm.filteredActivations), function(license, index) {
    return _c('bootstrap-modal', {
      attrs: {
        "title": "License Details",
        "name": 'attributesJson' + index
      }
    }, [_c('json', {
      attrs: {
        "jsonObject": license.attributes
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('date-range-picker', {
    attrs: {
      "placeHolder": "Licenses Issued Between",
      "ranges": _vm.datePickerRanges
    },
    on: {
      "daterange-change": _vm.dateRangeChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('h5', [_vm._v(_vm._s(_vm.dateRangeFormat(_vm.dateStart)) + " - " + _vm._s(_vm.dateRangeFormat(_vm.dateEnd)))])])]), _vm._v(" "), _c('form', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "activationsExpiredInput"
    }
  }, [_vm._v("Activations expired in last (days)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.expiresAgoDays),
      expression: "expiresAgoDays"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "activationsExpiredInput",
      "placeholder": "days"
    },
    domProps: {
      "value": _vm.expiresAgoDays,
      "value": _vm._s(_vm.expiresAgoDays)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.expiresAgoDays = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "activationsWillExpireDays"
    }
  }, [_vm._v("or in the next (days)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.expiresInDays),
      expression: "expiresInDays"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "activationsWillExpireDays",
      "placeholder": "days"
    },
    domProps: {
      "value": _vm.expiresInDays,
      "value": _vm._s(_vm.expiresInDays)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.expiresInDays = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.filteredActivations.length > 0) ? _c('div', [_c('p', [_vm._v("Showing " + _vm._s(_vm.licenseCount) + " license activations")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredActivations), function(lic, index) {
    return _c('tr', {
      class: lic.rowClass
    }, [_c('td', [_vm._v(_vm._s(_vm.formatDate(lic.activation.activateTime)))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'serial',
          params: {
            id: lic.activation.serial
          }
        }
      }
    }, [_vm._v(_vm._s(_vm.trim(lic.activation.serial, 8)))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.serialDetails[lic.activation.serial] ? _vm.serialDetails[lic.activation.serial].customer : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(lic.licenseExpiryDate.format('YYYY-MM-DD HH:mm')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Math.abs(lic.expiryDays)) + " " + _vm._s(lic.expiryDays < 0 ? 'days ago' : 'days'))]), _vm._v(" "), ('attributes' in lic) ? _c('td', [_c('a', {
      attrs: {
        "href": '#attributesJson' + index,
        "data-toggle": "modal"
      }
    }, [_vm._v("show")])]) : _c('td')])
  }))])]) : _c('div', [_c('span', [_vm._v("No license activations.")])])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Activation Date")]), _vm._v(" "), _c('th', [_vm._v("Serial")]), _vm._v(" "), _c('th', [_vm._v("Customer")]), _vm._v(" "), _c('th', [_vm._v("Expiry Date")]), _vm._v(" "), _c('th', [_vm._v("Expires")]), _vm._v(" "), _c('th', [_vm._v("Details")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5db7bdf1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReportLicenseExpiry.vue
// module id = 503
// module chunks = 2